export const getCategoryColor = (slug: string) => {
  switch (slug) {
    case "brand":
      return "magenta.700";
    case "content":
      return "purple.700";
    case "design":
      return "blue.700";
    case "inspiration":
      return "aqua.700";
    case "research":
      return "aqua.700";
    case "ux":
      return "earth.700";
    case "career":
      return "orange.700";
    default:
      return "";
  }
};
